import React, { useContext } from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { Box, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import UpcomingSubjectPapersHeader from './UpcomingSubjectPapersHeader';
import UpcomingSubjectPapersCard from './UpcomingSubjectPapersCard';
import { UpcomingSubjectPaperContext } from '../../../pages/subject/upcomingSubjectPapersBoard';

const useStyles = makeStyles()((theme) =>
({
  swiperContainer: {
    marginTop: theme.spacing(5),
    padding: theme.spacing(1),
    background: theme.color.background.bgNavigation,
  },
  swiperHeader: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  swiperSlide: {
    maxWidth: theme.spacing(35),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(1),
  },
  noAnnouncementMessage: {
    height: theme.spacing(10),
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.color.text.textAccent,
    paddingBottom: theme.spacing(4),
  },
}));

const MobileUpcomingSubjectPapers = () => {
  const upcomingSubjectPapers = useContext(UpcomingSubjectPaperContext);
  const { classes } = useStyles();

  const { t } = useTranslation();

  return (
    <Box className={classes.swiperContainer}>
      <Box className={classes.swiperHeader}>
        <UpcomingSubjectPapersHeader
          totalUpcomingSubjectPapers={upcomingSubjectPapers.length}
          isDesktopView={false}
          isFirstPage={false}
          isEndPage={false}
        />
      </Box>
      {upcomingSubjectPapers.length !== 0 ? (
        <Box>
          <Swiper pagination modules={[Pagination]} slidesPerView="auto">
            {upcomingSubjectPapers.map((upcomingSubjectPaperDetail) => (
              <SwiperSlide
                key={upcomingSubjectPaperDetail.subjectPaper}
                className={classes.swiperSlide}
              >
                <UpcomingSubjectPapersCard {...upcomingSubjectPaperDetail} />
              </SwiperSlide>
            ))}
          </Swiper>
          <Typography className={classes.noAnnouncementMessage} variant="caption">
            {t('admin->>UpcomingSubjectPapers.UpcomingSubjectNotes')}
          </Typography>
        </Box>
      ) : (
        <Typography className={classes.noAnnouncementMessage} variant="h3">
          {t('admin->>UpcomingSubjectPapers.NoUpcomingSubjectMessage')}
        </Typography>
      )}
    </Box>
  );
};

export default MobileUpcomingSubjectPapers;
